import React from "react"
import styled from "styled-components"
import beneficiary from "../../assist/icons/about/IconNumbers/beneficiaries.svg"
import basket from "../../assist/icons/about/IconNumbers/box.svg"
import bread from "../../assist/icons/about/IconNumbers/prid.svg"
import dailyMeal from "../../assist/icons/about/IconNumbers/food.svg"
import tent from "../../assist/icons/about/IconNumbers/tent.svg"
import clothing from "../../assist/icons/about/IconNumbers/clothes.svg"
import healthSupplies from "../../assist/icons/about/IconNumbers/fuel.svg"
import orphan from "../../assist/icons/about/IconNumbers/orphent.svg"
import medicalTeam from "../../assist/icons/about/IconNumbers/midical.svg"
import medicinMedicalSupplies from "../../assist/icons/about/IconNumbers/midicen.svg"
import dialysisCenter from "../../assist/icons/about/IconNumbers/idneyDialysis.svg"
import educationCenter from "../../assist/icons/about/IconNumbers/edu.svg"
import training from "../../assist/icons/about/IconNumbers/course.svg"
import loan from "../../assist/icons/about/IconNumbers/loan.svg"
import sanitation from "../../assist/icons/about/IconNumbers/underWater.svg"
import literOfWater from "../../assist/icons/about/IconNumbers/water.svg"
import CountUp from "react-countup"
import NumbersHorizantal from "./NumbersHorizantal"
import { useStaticQuery, graphql } from "gatsby"

const icons = {
  beneficiary,
  basket,
  bread,
  dailyMeal,
  tent,
  clothing,
  healthSupplies,
  orphan,
  medicalTeam,
  medicinMedicalSupplies,
  dialysisCenter,
  educationCenter,
  training,
  loan,
  sanitation,
  literOfWater,
}

const Numbers = ({ lang }) => {
  const data = useStaticQuery(graphql`
    {
      list: allStrapiAboutAchivementsLists {
        edges {
          node {
            ar {
              name
            }
            en {
              name
            }
            tr {
              name
            }
            nunber
            type
            id
          }
        }
      }
    }
  `)
  const numbers = data.list.edges
  const achivement_content = () =>
    numbers.map(number => (
      <div className="content" key={number.node.id}>
        <img src={icons[number.node.type]} alt="icon" />
        <CountUp
          separator=" "
          delay={8}
          duration={10}
          end={number.node.nunber}
        />
        <p>{number.node[lang].name}</p>
      </div>
    ))
  return (
    <Wraper>
      <div className="fullScreenStyle">{achivement_content()}</div>
      <div className="mobileStyle">
        <NumbersHorizantal>{achivement_content()}</NumbersHorizantal>
      </div>
    </Wraper>
  )
}
export default Numbers

const Wraper = styled.div`
  .mobileStyle {
    display: none;
  }
  .fullScreenStyle {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
  }
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px 0;
    &:hover {
      background: ${props => props.theme.aboutback};
      border-radius: 15px;
      transition: ${props => props.theme.tr};
    }
    img {
      width: 35%;
      height: 60px;
    }
    span {
      font-size: 2rem;
      font-weight: bolder;
    }
    p {
      color: ${props => props.theme.lg};
      font-size: 1.3rem;
    }
  }
  @media (max-width: 1190px) {
    .fullScreenStyle {
      grid-template-columns: repeat(3, 1fr);
    }
  }
  @media (max-width: 900px) {
    .fullScreenStyle {
      .content {
        p {
          font-size: 1.1rem;
        }
      }
    }
  }
  @media (max-width: 800px) {
    .fullScreenStyle {
      grid-template-columns: repeat(2, 1fr);
    }
    span {
      font-size: 1.5rem !important;
    }
    p {
      font-size: 1rem !important;
    }
  }
  @media (max-width: 670px) {
    .fullScreenStyle {
      display: none;
    }
    .mobileStyle {
      display: block;
      .content {
        display: grid !important;
        place-items: center;
        gap: 5px;
      }
    }
  }

  @media (max-width: 500px) {
    .slick-arrow .slick-next,
    .slick-next:before,
    .slick-prev:before {
      display: block;
    }
  }
`
